<script>
  import {mapGetters, mapActions} from 'vuex'
  import * as restfulService from '../../services/restfulService'
  import * as notifyService from '../../services/notifyService'
  import * as authService from '../../services/authService'
  import {clone} from 'lodash'

  export default {
    name: 'app-header',
    computed: {
      ...mapGetters(['currentUser', 'collapseMenu'])
    },
    data () {
      return {
        isSubmitted: false,
        showChangePasswordModal: false,
        changePassword: {
          current_password: '',
          password: '',
          password_confirmation: ''
        }
      }
    },
    methods: {
      ...mapActions(['setCollapseMenu']),
      handleDropdownCommand (command) {
        if (command === 'changePassword') {
          this.showChangePasswordModal = true
        }
        if (command === 'logout') {
          this.onLogout()
        }
      },
      toggleCollapseMenu () {
        this.setCollapseMenu(!this.collapseMenu)
      },
      onChangePassword () {
        this.isSubmitted = true
        const data = clone(this.changePassword)
        restfulService.put('user', this.currentUser.id, 'change-password', data)
          .then(_ => {
            this.isSubmitted = false
            this.showChangePasswordModal = false
            this.changePassword = {}
            notifyService.success({hideLoader: true, message: 'A senha foi alterada'})
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      },
      onLogout () {
        authService.logout()
          .then(() => {
            this.$router.push({name: 'auth'})
          })
      }
    }
  }
</script>

<template>
    <div>
        <div class="app-bar">
            <div class="app-bar-content">
                <div class="app-bar-logo">
                    <a href="">
                        <span class="text-full"><strong>Sistema</strong> Eventos</span>
                        <span class="text-mobile"><strong>SE</strong></span>
                    </a>
                    <div class="toggle-menu" @click="toggleCollapseMenu">
                        <i class="fa fa-bars"></i>
                    </div>
                </div>
                <div class="app-bar-user">
                    <el-dropdown @command="handleDropdownCommand">
                        <span class="el-dropdown-link">
                        {{currentUser.name}} <i class="el-icon-caret-bottom el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="changePassword">
                                <span>Alterar Senha</span>
                            </el-dropdown-item>
                            <el-dropdown-item command="logout">
                                <i class="fa fa-sign-out"></i>
                                <span>Sair</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <el-dialog title="Alteração de senha"
                   size="tiny"
                   v-loading.body="isSubmitted"
                   element-loading-text="Gravando dados..."
                   v-if="showChangePasswordModal"
                   :visible.sync="showChangePasswordModal">
            <el-form ref="form" :model="changePassword" label-width="120px">
                <el-form-item label="Senha atual">
                    <el-input type="password" v-model="changePassword.current_password"></el-input>
                </el-form-item>
                <el-form-item label="Senha">
                    <el-input type="password" v-model="changePassword.password"></el-input>
                </el-form-item>
                <el-form-item label="Confirmação">
                    <el-input type="password" v-model="changePassword.password_confirmation"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"
                               :disabled="isSubmitted"
                               @click="onChangePassword">Salvar nova senha
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>



// WEBPACK FOOTER //
// Header.vue?70846562